import React, { Component, Fragment } from "react";
import { Alert, Form } from "react-bootstrap";
import { Dropdown } from "semantic-ui-react";
import AlertNoPermission from "../../alerts/AlertNoPermission";
import LoadingProgressBar from "../../spinners/LoadingProgressBar";
import $ from "jquery";
import DescPopover from "../../popovers/DescPopover";

class RoomKeepers extends Component {
    state = { partsFullname: null, noPermission: false };

    getPartsFullname = async () => {
        const { fetchURL, onShowAlert, activeEvent, defaultValue, t } = this.props;
        const passData = {
            eventCode: activeEvent.code,
            selectedPart: defaultValue ? defaultValue : null,
        };
        try {
            const response = await fetch(`${fetchURL}/room-keepers`, {
                credentials: "include",
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(passData),
            });
            if (response.status === 200) {
                await response.json().then((fetchedData) => {
                    // //console.log(fetchedData);
                    if (fetchedData.status === "noPermission") this.setState({ noPermission: true });
                    else if (fetchedData.status === "notLogged") this.props.onShowHomePage();
                    else if (fetchedData.status === false) onShowAlert({ variant: "danger", message: t(`error.${fetchedData.code}`) });
                    else this.setState({ partsFullname: fetchedData.partsFullname });
                });
            }
        } catch (err) {
            onShowAlert({ variant: "danger", message: `${t("error.cannotFetchData")} (${err})` });
            this.setState({ loading: false });
        }
    };

    componentDidMount() {
        this.getPartsFullname();
    }

    render() {
        const { partsFullname, noPermission } = this.state;
        const { labelTxt, onFullnameSelected, value, req, helper, t } = this.props;
        return (
            <Fragment>
                <Form.Label className="w-100">
                    {labelTxt} {req && <span className="required">*</span>}
                    {helper && (
                        <div className="float-right">
                            <DescPopover placement="top" popoverTxt={<p>{helper}</p>} t={t} />
                        </div>
                    )}
                </Form.Label>
                {noPermission ? (
                    <AlertNoPermission t={t} />
                ) : partsFullname ? (
                    partsFullname.length > 0 ? (
                        <Dropdown
                            value={value}
                            id="roomKeepeersDropdown"
                            className="req mb-3"
                            placeholder={t("selectOrType")}
                            fluid
                            search
                            selection
                            options={partsFullname}
                            onChange={(event, { value }) => {
                                $("#roomKeepeersDropdown").removeClass("danger");
                                onFullnameSelected(value);
                            }}
                            noResultsMessage={t("participant.partNotFound")}
                        />
                    ) : (
                        <Alert variant="warning">{t("user.noUsers")}</Alert>
                    )
                ) : (
                    <LoadingProgressBar t={t} />
                )}
            </Fragment>
        );
    }
}

export default RoomKeepers;
